/* eslint-disable */
import { withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { EVENTS } from '../../app/constants/events';
import { NAV_DATA_KEY } from '../../app/constants/app';
import { clearAccountsList, updateAccountsList, updateUserInfo } from '../../app/account/store/account.actions';
import { selectAccountsList, selectIsLogged, selectIsLoggedOut } from '../../app/account/store/account.selectors';
import { selectAccounts, selectLastlyCreatedAccount } from '../../app/settings/store/accounts/accounts.selectors';
import { getSSOFlag, setIntegrateIOFlag, setSSOFlag } from '../../app/account/helpers/account.helpers';

xplenty.run([
  '$state',
  '$rootScope',
  '$location',
  '$window',
  '$translate',
  '$urlRouter',
  '$log',
  '$timeout',
  '$http',
  'pusherService',
  'segment',
  'headersService',
  'visibilityService',
  'offline',
  'notify',
  'modalService',
  'permissionService',
  'User',
  'Account',
  'Region',
  'NavigationHotkeys',
  'md5',
  'accountService',
  'validationExportsService',
  'herokuBoomerangService',
  'ngrxStoreService',
  'AuthService',
  '$stateParams',

  function (
    $state,
    $rootScope,
    $location,
    $window,
    $translate,
    $urlRouter,
    $log,
    $timeout,
    $http,
    pusherService,
    segment,
    headersService,
    visibilityService,
    offline,
    notify,
    modalService,
    permissionService,
    User,
    Account,
    Region,
    NavigationHotkeys,
    md5,
    accountService,
    validationExportsService,
    herokuBoomerangService,
    ngrxStoreService,
    AuthService,
    $stateParams,
  ) {
    $rootScope.$log = $log;
    $rootScope.loadingAccountsSubject = new BehaviorSubject(null);

    $rootScope.setQueryParams = (key, value) => {
      $location.search(key, value);
    };

    $rootScope.getQueryParams = (key) => {
      return $location.search()[key];
    };

    $rootScope.stateGo = (state, params = {}, openInNewTab = false) => {
      if (openInNewTab) {
        const url = $state.href(state, params);
        window.open(url, '_blank');
      } else {
        $state.go(state, params);
      }
    };

    $rootScope.getCurrentState = () => {
      return $state.current.name;
    };

    $rootScope.getHref = (state) => {
      return $state.href(state);
    };

    $rootScope.stateIs = (state) => {
      return $state.is(state);
    };

    $rootScope.stateIncludes = (state) => {
      return $state.includes(state);
    };

    ngrxStoreService.pipe(selectIsLogged).subscribe(() => {
      getUserAndAccountsData();
    });

    ngrxStoreService.pipe(selectIsLoggedOut).subscribe(() => {
      modalService.hideModal();
      pusherService.unsubscribeUser();
      pusherService.unsubscribeAccount();
      $window.localStorage.removeItem(NAV_DATA_KEY);
      herokuBoomerangService.init();

      resetRootScope();
      clearPermissions();
    });

    $rootScope.isAuthenticated = function () {
      return AuthService.isAuthenticated();
    };

    function goToLogin() {
      $state.go('app.auth.signin');
    }

    $rootScope.getMockUserAndAccountsData = function () {
      const mockAccount = {
        permissions: ['listConnections', 'listPackages', 'listJobs', 'listClusters', 'listSchedules', 'viewProfile'],
        is_owner: true,
        account_id: 'welcome',
      };
      const { email } = $location.search();
      ngrxStoreService.dispatch(updateAccountsList({ accounts: [mockAccount] }));

      // Extract email and name from query parameters. This is the protocol from marketing
      if (email) {
        const gravatar_id = md5.createHash(email.trim().toLowerCase());

        const user = {
          email,
          mock: true,
          avatar_url: `${
            document.location.protocol === 'https:' ? 'https://secure.' : 'http://'
          }gravatar.com/avatar/${gravatar_id}.png?d=${encodeURIComponent(
            'https://assets.xplenty.com/app/avatars/guest.png',
          )}`,
          name: $location.search().name,
        };
        $rootScope.user = user;

        ngrxStoreService.dispatch(updateUserInfo({ user }));
      }
    };

    $rootScope.isEnabled = function (event) {
      return !$(event.currentTarget).is('[disabled]');
    };

    // Update moment locale
    const calendarCallback = function callback(now) {
      // If we are in current year, do not include it.
      if (now.year() == this.year()) {
        return 'MMM Do [at] LTS';
      }
      return 'MMM Do, YYYY [at] LTS';
    };
    moment.updateLocale('en', {
      // Override  all times to be 24hr based
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY LT',
        LLLL: 'dddd, MMMM D, YYYY LT',
      },
      calendar: {
        sameDay: '[Today] [at] LTS',
        nextDay: '[Tomorrow] [at] LTS',
        nextWeek: calendarCallback,
        lastDay: '[Yesterday] [at] LTS',
        lastWeek: calendarCallback,
        sameElse: calendarCallback,
      },
    });
    // Set moment thresholds
    moment.relativeTimeThreshold('s', 60);
    moment.relativeTimeThreshold('m', 60);
    moment.relativeTimeThreshold('h', 24);
    moment.relativeTimeThreshold('d', 31);
    moment.relativeTimeThreshold('M', 12);

    $rootScope.brandName = 'Xplenty';
    $rootScope.lng = 'en';

    moment.locale($rootScope.lng);

    const isPasswordResetURL = window.location.href.includes('password_reset');

    if (!isPasswordResetURL) {
      segment.init(window.SEGMENT_KEY);
    }

    headersService.init();
    visibilityService.init();

    $rootScope.$on('$stateChangePermissionStart', function (event, toState, toParams, options) {
      if (toState.name === '401' || toState.name === '404') {
        event.preventDefault();
      } else if (toParams.account_id) {
        permissionService.setCurrentAccount(toParams.account_id);
      } else {
        permissionService.setCurrentAccount(null);
      }
    });

    $rootScope.$on('$stateChangePermissionDenied', function (event, toState, toParams) {
      event.preventDefault();
      $state.go('401', toParams, { location: false });
    });

    function goToLogin() {
      if (($rootScope.user || {}).integrateio_id && !getSSOFlag()) {
        window.location = `${process.env.INTEGRATEIO_URL}/auth/login`;
      } else {
        $state.go('app.auth.signin');
      }
    }

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      const requireLogin = toState.data && toState.data.requireLogin;

      if (requireLogin && !AuthService.isAuthenticated()) {
        $rootScope.$log.info('Not authenticated, redirecting to login page.');
        event.preventDefault();
        // get me a login modal!
        $timeout(function () {
          goToLogin();
        });
        return;
      }

      if (toState.name === 'welcome' || toState.name === 'welcome.start') {
        $rootScope.getMockUserAndAccountsData();
      }

      if (toState.title) {
        $translate(toState.title, toParams).then(function (title) {
          $rootScope.title = title;
        });
      }
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      const path = $location.path();
      let querystring = '';
      let referrer = '';

      if (path.indexOf('?') !== -1) {
        querystring = path.substring(path.indexOf('?'), path.length);
      }

      if (fromState.name) {
        referrer = `${$location.protocol()}://${$location.host()}${fromState.url}`;
      }

      if (!isPasswordResetURL) {
        segment.page($rootScope.title, {
          path,
          search: querystring,
          referrer,
          title: $rootScope.title,
          url: $location.absUrl(),
        });

        if ($rootScope.user) {
          segment.identify($rootScope.user.email, $rootScope.user.event_traits);
        }
      }

      // Default redirections
      if (toState.name === 'app.account') {
        event.preventDefault();
        $state.go('app.account.jobs');
      }

      // Default redirections
      if (toState.name === 'app.account.settings') {
        event.preventDefault();
        $state.go('app.account.settings.account.info');
      }

      // Bind application wide keys only if signed up
      NavigationHotkeys.reset();
      if (AuthService.isAuthenticated()) {
        NavigationHotkeys.bindCategories(['shortcuts.list.category.application']);

        if (toParams.account_id) {
          NavigationHotkeys.bindCategories(['shortcuts.list.category.navigation']);
        }

        if (toState.name == 'app.account.packages.item' || toState.name == 'app.account.packages.item.edit') {
          // Reset navigation keys based on current route
          NavigationHotkeys.bindCategories(['shortcuts.list.category.designer']);
        }
      }
      if (toState.name === 'welcome' || toState.name === 'welcome.start') {
        NavigationHotkeys.bindCategories(['shortcuts.list.category.application', 'shortcuts.list.category.navigation']);
      }

      // TODO: Possible fix for query params dropped between state changes
      // $location.search($rootScope.locationSearch);
    });

    herokuBoomerangService.init();

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      console.log('StateChangeError! ', event);
      if (error === 'DATAFLOW_NOT_SUPPORTED' && window.APP_URL != null) {
        // Redirect to app.xplenty.com
        $window.location.href = `${window.APP_URL}/${toParams.account_id}/packages/${toParams.id}${toState.url}`;
      }
    });

    $rootScope.$on('$viewContentLoaded', function (event) {
      angular.element('.page-scroll-wrapper').scrollTop(0);
    });

    $rootScope.$on(EVENTS.SHORTCUTS_DISPLAY_LIST, function (event, shortcuts) {
      const $tempScope = $rootScope.$new();

      $tempScope.shortcuts = shortcuts;

      $translate([
        'app.controller.modals.shortcuts.actions.title',
        'app.controller.modals.shortcuts.actions.close',
      ]).then(function (t) {
        const modalSettings = {
          titleText: t['app.controller.modals.shortcuts.actions.title'],
          closeButtonText: t['app.controller.modals.shortcuts.actions.close'],
          saveButtonHidden: true,
          thin: true,
          hasPadding: false,
          hasFooter: false,
        };
        modalService.showModal(modalSettings, '<shortcuts-list ng-model="shortcuts">', $tempScope);
      });
    });

    const resetRootScope = function () {
      console.log('Resetting root scope!');
      delete $rootScope.user;
      delete $rootScope.account;
    };

    const getUserAndAccountsData = function () {
      $rootScope.user = null;
      ngrxStoreService.dispatch(clearAccountsList());

      User.get({
        include: 'event_traits',
      }).subscribe(
        function (user) {
          $rootScope.user = user;

          setIntegrateIOFlag(user);
          setSSOFlag(user);

          if (user.is_dpwc) {
            $rootScope.is_dpwc = true;
          }
          ngrxStoreService.dispatch(updateUserInfo({ user }));
          pusherService.initUser(user.id);
          if (!isPasswordResetURL) {
            segment.identify($rootScope.user.email, $rootScope.user.event_traits);
          }
          DEFAULT_TIMEZONE = user.time_zone_info.offset;
        },
        function () {
          notify.error('Error loading user data.');
        },
      );

      accountService.loadCurrentAccount().subscribe(() => {
        accountService.loadAccounts().subscribe((accounts) => {
          permissionService.init([...accounts, accountService.currentAccount]);
          $urlRouter.sync();
          $urlRouter.listen();
        });
      });

      ngrxStoreService
        .select(selectAccounts)
        .pipe(withLatestFrom(ngrxStoreService.select(selectLastlyCreatedAccount)))
        .subscribe(([accounts, account]) => {
          permissionService.init([...accounts, account, accountService.currentAccount]);

          if ($rootScope.stateIs('app.launchpad') && account) {
            $rootScope.stateGo('app.account.jobs', { account_id: account.account_id });
          }
        });

      Region.query('', {
        sort: 'name',
        direction: 'asc',
        limit: 100,
      }).subscribe(
        function (regions) {
          $rootScope.regions = regions;
          $rootScope.$broadcast(EVENTS.REGIONS_LIST_LOADED, regions);
        },
        function () {
          notify.error('Error loading regions.');
        },
      );
    };

    if (AuthService.isAuthenticated()) {
      getUserAndAccountsData();
    }

    function clearPermissions() {
      permissionService.clear();
    }

    if (!AuthService.isAuthenticated()) {
      clearPermissions();
      $urlRouter.sync();
      $urlRouter.listen();
    }

    const ADBLOCK_NOTIFY = 'adblock_notify';

    function getAdblockNotify() {
      let adblockNotify = window.localStorage.getItem(ADBLOCK_NOTIFY);
      if (adblockNotify === null) {
        adblockNotify = 'true';
        setAdblockNotify(adblockNotify);
      }
      return adblockNotify;
    }

    function setAdblockNotify(notify) {
      window.localStorage.setItem(ADBLOCK_NOTIFY, notify);
    }

    // Function called if AdBlock is detected
    function adBlockDetected() {
      if (getAdblockNotify() === 'true') {
        $translate(['adblock.title', 'adblock.description']).then(function (t) {
          notify.alert(t['adblock.title'], t['adblock.description'], 'warning', {
            type: 'warning',
            delay: 7000,
          });
          angular.element('.notify [data-notify="dismiss"]').on('click', function () {
            setAdblockNotify(false);
          });
        });
      }
    }

    // This means that AdBlock is present
    if (typeof fuckAdBlock !== 'undefined') {
      fuckAdBlock.onDetected(adBlockDetected);
      fuckAdBlock.setOption({
        debug: false,
        checkOnLoad: false,
        resetOnEnd: false,
      });
    }
    // TODO: Listen for any change on current user update (Pusher event

    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
      const re = new RegExp(`^${this.term}`);
      const t = item.label.replace(re, `<span class='ui-state-highlight'>${this.term}</span>`);
      return $('<li></li>').data('item.autocomplete', item).append(t).appendTo(ul);
    };
  },
]);
